<template>
  <div>
    <div class="is-flex is-align-items-center">
      <p class="section_title"><b>פרטי השמה</b>:</p>
      <div class="horizontal_space"></div>
      <div v-if="form.data.offer.fields.id != undefined">
        <a @click="cancelOffer" class="is-danger button" :class="{ 'is-loading': is_cancelling }">Cancel</a>
      </div>
    </div>
    <div>
        <div class="is-flex is-align-items-center">
          <p><b>מועמד/ת</b>:</p>
          <div class="horizontal_space"></div>
          <input class="outlined" v-model="form.data.offer.fields.applicant_name.value"
                :class="{ field_error: form.data.offer.fields.applicant_name.has_error }"
                @focus="form.data.offer.fields.applicant_name.has_error = false">
        </div>
        <div class="vertical_space"></div>
        <div class="is-flex is-align-items-center">
          <p><b>שכר</b>:</p>
          <div class="horizontal_space"></div>
          <div class="is-flex is-align-items-center">
            <input class="outlined" v-model="form.data.offer.fields.salary.value"
                  :class="{ field_error: form.data.offer.fields.salary.has_error }"
                  @focus="form.data.offer.fields.salary.has_error = false"
                  placeholder="למשל 10000">
            <div class="horizontal_space"></div>
            <checkbox v-model="form.data.offer.fields.salary_verified.value" :checked="form.data.offer.fields.salary_verified.value">
              מאושר
            </checkbox>
          </div>
        </div>
        <div class="vertical_space"></div>
        <div class="is-flex">
          <p class="m-0"><b>הודעה</b>:</p>
          <div class="horizontal_space"></div>
          <textarea v-model="form.data.offer.fields.message.value"></textarea>
        </div>
        <div style="max-width: 300px;">
          <div class="mt-5 is-flex is-justify-content-space-between is-align-items-center">
            <p class="m-0"><b>vetting</b>:</p>
            <select class="ltr" v-model="form.data.offer.fields.vetting.value">
              <option v-for="option in dropdownAdminsNames" :key="option">{{ option }}</option>
            </select>
          </div>
          <div class="mt-5 is-flex is-justify-content-space-between is-align-items-center">
            <p class="m-0"><b>איתור</b>:</p>
            <select class="ltr" v-model="form.data.offer.fields.strong.value">
              <option v-for="option in dropdownAdminsNames" :key="option">{{ option }}</option>
            </select>
          </div>
          <div class="mt-5 is-flex is-justify-content-space-between is-align-items-center">
            <p class="m-0"><b>שליחה</b>:</p>
            <select class="ltr" v-model="form.data.offer.fields.send_by.value">
              <option v-for="option in dropdownAdminsNames" :key="option">{{ option }}</option>
            </select>
          </div>
        </div>
        <div class="mt-5 vertical_space"></div>
        <div class="is-flex is-align-items-center">
          <p><b>אחוז השמה</b>:</p>
          <div class="horizontal_space"></div>
          <div class="is-flex is-align-items-center">
            <input class="outlined small_input" v-model="form.data.offer.fields.percentage.value"
                  :class="{ field_error: form.data.offer.fields.percentage.has_error }"
                  @focus="form.data.offer.fields.percentage.has_error = false">
            <div class="horizontal_space"></div>
            <checkbox v-model="form.data.offer.fields.percentage_verified.value" :checked="form.data.offer.fields.percentage_verified.value">
              מאושר
            </checkbox>
          </div>
        </div>
        <div class="vertical_space"></div>
        <div class="is-flex is-align-items-center">
          <p><b>ימים לדרישת תשלום</b>:</p>
          <div class="horizontal_space"></div>
          <input class="outlined small_input" v-model="form.data.offer.fields.maturation_days.value"
                :class="{ field_error: form.data.offer.fields.maturation_days.has_error }"
                @focus="form.data.offer.fields.maturation_days.has_error = false">
        </div>
        <div class="vertical_space"></div>
        <div class="is-flex is-align-items-center">
          <p><b>תחילת עבודה</b>:</p>
          <div class="horizontal_space"></div>
          <input dir="ltr" v-model="form.data.offer.fields.start_date.value"
                 :class="{ field_error: form.data.offer.fields.start_date.has_error}" placeholder="20/03/2017" type="date" />
        </div>
    </div>
  </div>
</template>
<script>
import TimeHelper from '@/custom/classes/time_helper.js'
import Checkbox from '@/components/Checkbox'
import { mapGetters } from 'vuex'

export default {
  name: 'accounting-offer-form',
  props: ['offer'],
  data () {
    let env = this.$settings.get({ path: 'operation_name' })
    return {
      is_cancelling: false,
      time_helper: new TimeHelper(),
      form: new this.$form({
        offer: {
          fields: {
            applicant_name: {
              value: this.offer.applicant.first_name + ' ' + this.offer.applicant.last_name,
              has_error: false,
              validations: ['Exists']
            },
            position_title: {
              value: this.offer.position.title,
              has_error: false,
              validations: ['Exists']
            },
            company_id: {
              value: '',
              has_error: false,
              validations: ['Exists']
            },
            salary: {
              value: '',
              has_error: false,
              validations: ['Exists', 'Number']
            },
            salary_verified: {
              value: false,
              has_error: false,
              validations: ['Exists']
            },
            message: {
              value: `vetting&1&${'\n'}איתור&2&${'\n'}שליחה&3&${'\n'}מעסיק - `,
              has_error: false,
              validations: []
            },
            percentage: {
              value: '',
              has_error: false,
              validations: ['Exists', 'Number']
            },
            percentage_verified: {
              value: false,
              has_error: false,
              validations: ['Exists']
            },
            maturation_days: {
              value: '',
              has_error: false,
              validations: ['Number']
            },
            start_date: {
              value: '',
              has_error: false,
              validations: ['Exists']
            },
            vetting: {
              value: '',
              has_error: false,
              validations: []
            },
            strong: {
              value: '',
              has_error: false,
              validations: []
            },
            send_by: {
              value: '',
              has_error: false,
              validations: []
            },
            env: {
              value: env,
              has_error: false,
              validations: ['Exists']
            },
            env_offer_id: {
              value: this.offer.id,
              has_error: false,
              validations: ['Exists']
            },
            recruiter_name: {
              value: this.$utils.getOwner().name,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: 'post',
            url: '/create_accounting_offer/',
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    }
  },
  computed: {
    ...mapGetters('admins', ['dropdownAdminsNames'])
  },
  created () {
    this.setPlaceholderMessage()
    this.updateParentForm()
  },
  watch: {
    form: {
      handler () {
        this.updateParentForm()
      },
      deep: true
    }
  },
  methods: {
    selectOffer (offer) {
      this.form.data.offer.fields.percentage.value = offer.percentage
      this.form.data.offer.fields.percentage_verified.value = offer.percentage_verified
      this.form.data.offer.fields.maturation_days.value = offer.maturation_days
      this.form.data.offer.fields.message.value = offer.message
      this.form.data.offer.fields.salary.value = offer.salary
      this.form.data.offer.fields.vetting.value = offer.vetting
      this.form.data.offer.fields.strong.value = offer.strong
      this.form.data.offer.fields.send_by.value = offer.send_by
      this.form.data.offer.fields.salary_verified.value = offer.salary_verified
      this.form.data.offer.fields.start_date.value = this.time_helper.getDateInput(offer.start_date)
      this.form.data.offer.fields.id = {
        value: offer.id,
        has_error: false,
        validations: ['Exists']
      }
      this.form.data.offer.request_details.method = 'put'
      this.form.data.offer.request_details.url = '/update_accounting_offer/'
      this.form.data.offer.fields.applicant_name.value = offer.applicant_name
    },
    cancelOffer () {
      if (!confirm('האם לבטל את ה- Offer?')) {
        return
      }
      this.is_cancelling = true
      this.$network_utils.updateAccountingOffer({
        id: this.form.data.offer.fields.id.value,
        env: this.form.data.offer.fields.env.value,
        status: 'canceled'
      }).then(() => {
        this.is_cancelling = false
        this.$emit('cancel')
        this.$utils.emit('show_toast', { text: 'Offer has been canceled' })
      })
    },
    async setPlaceholderMessage () {
      const nameArray = [this.offer.applicant.owner]
      const strong = await this.$network_utils.getStats({ placeholder_message: 'TRUE', resource_id: this.offer.id, designator: 'offer_to_awaiting_applicant_strong' })
      const send = await this.$network_utils.getStats({ placeholder_message: 'TRUE', resource_id: this.offer.id, designator: 'offer_to_awaiting_company_sent' })
      this.form.data.offer.fields.vetting.value = this.offer.applicant.owner
      this.form.data.offer.fields.strong.value = strong.owner
      this.form.data.offer.fields.send_by.value = send.owner
      let replaceValue = ' - '
      nameArray.push(strong.owner)
      nameArray.push(send.owner)
      nameArray.forEach(async (name, idx) => {
        if (name) {
          const user = await this.checkUserStatus(name)
          if (user[0]) {
            replaceValue = ` - ${name}`
          }
        }
        const text = this.form.data.offer.fields.message.value
        this.form.data.offer.fields.message.value = text.replace(`&${idx + 1}&`, replaceValue)
      })
    },
    checkUserStatus (name) {
      return this.$network_utils.getUsers({ resource_type: 'Admin', status: 'active', name: name })
    },
    setCompanyData (company) {
      this.form.data.offer.fields.percentage.value = company.percentage
      this.form.data.offer.fields.maturation_days.value = company.maturation_days
      this.form.data.offer.fields.company_id.value = company.id
    },
    updateParentForm () {
      this.$emit('input', this.form.data.offer)
    }
  },
  components: {
    Checkbox
  }
}
</script>
